<template>
  <div class="home-wrap">
    <div class='large-screen-wrap' :style="largeScreenStyle">
      <Header></Header>
      <div class="showBlock">
        <leftBlock></leftBlock>
        <middleBlock></middleBlock>
        <rightBlock></rightBlock>
      </div>
      <bottomBlock></bottomBlock>
    </div>
  </div>
</template>

<script>
import Header from './components/Header'
import bottomBlock from './components/bottomBlock'
import leftBlock from './components/leftBlock'
import rightBlock from './components/rightBlock'
import middleBlock from './components/middleBlock'
import {
  getScale,
  designHeight,
  designWidth
} from '@/utils/getScalc'
export default {
  data() {
    return {
      // 响应式变量
      designHeight,
      designWidth,
      scale: getScale(), // 初始化时候就进行一次获取比例
      timer: true // 防抖
    }
  },
  components: {
    Header,
    bottomBlock,
    leftBlock,
    rightBlock,
    middleBlock
  },
  computed: {
    largeScreenStyle() {
      return {
        transform: `scale(${this.scale[0]}, ${this.scale[1]}) translateX(-50%)`,
        height: `${this.designHeight}px`,
        width: `${this.scale[2]}px`
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.setScalc)
  },
  methods: {
    // 设置缩放比例
    setScalc() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.scale = getScale()
          // this.resize()
        }, 500)
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setScalc)
  }
}
</script>

  <style></style>
